import { useATTrackInteraction } from '@at/consumer-web-snowplow';
// hooks for tracking interactions in the ConnectedFooter component
export const useTrackSocialInteraction = () => {
    const fireTrackInteraction = useATTrackInteraction();
    return ({ socialName }) => {
        fireTrackInteraction({
            trackingLabel: `social-icon ${socialName}`,
        });
    };
};
export const useTrackFooterLinkInteraction = () => {
    const fireTrackInteraction = useATTrackInteraction();
    return ({ labelIdentifier }) => {
        fireTrackInteraction({
            trackingLabel: labelIdentifier,
        });
    };
};
export const useTrackAccordionInteraction = () => {
    const fireTrackInteraction = useATTrackInteraction();
    return ({ isExpanded, rowIndex }) => {
        fireTrackInteraction === null || fireTrackInteraction === void 0 ? void 0 : fireTrackInteraction({
            trackingLabel: `accordion footer: row-${rowIndex}  ${isExpanded ? 'expanded' : 'collapsed'} `,
        });
    };
};
// Main tracking hook to be used in the ConnectedFooter component
export const useTrackFooterLogic = () => {
    const onSocialClick = useTrackSocialInteraction();
    const onFooterLinkClick = useTrackFooterLinkInteraction();
    const onFeedbackClick = useATTrackInteraction({
        trackingLabel: 'send feedback footer',
    });
    const onAccordionClick = useTrackAccordionInteraction();
    const onCompanyInfoClick = useATTrackInteraction({
        trackingLabel: 'company info footer',
    });
    // Return all tracking callbacks
    return {
        onSocialClick,
        onFooterLinkClick,
        onFeedbackClick,
        onAccordionClick,
        onCompanyInfoClick,
    };
};
